var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h4',[_vm._v("Visualizações BI")]),_vm._l((_vm.model.powerBIViews),function(row){return _c('div',{key:row.powerBIViewId,staticClass:"form-group"},[_c('base-checkbox',{model:{value:(row.active),callback:function ($$v) {_vm.$set(row, "active", $$v)},expression:"row.active"}},[_vm._v(_vm._s(row.powerBIViewName))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }